import con from '../../../connection';
var path = '/logout';
var logout = function (url) { return function () { return ({
    post: function () { return con.post(url + path, {}); },
}); }; };
export default logout;
